import { RouterLocation } from 'connected-react-router'
import { AppDispatch, AppState } from '.'

export function createAction<T extends (...args: unknown[]) => ReturnType<T>>(
	dispatch: AppDispatch,
	action: T
) {
	return (...args: Parameters<T>) => {
		dispatch(action(...args))
	}
}

// Use only in saga, for components use react-router hooks: useHistory, useLocation, etc.
export const selectHistory = <T = unknown>(state: AppState) => ({
	location: state.router.location as RouterLocation<T>,
	action: state.router.action,
})
